export const MODULE_PREFIX = 'arrivalTime';
